import _ from 'lodash';

const appUtils = {
  isNull(obj) {
    if (obj === null) {
      return true;
    }
    return false;
  },

  isBlank(obj) {
    if (_.isUndefined(obj) || _.isEmpty(obj)) {
      return true;
    }
    return false;
  },

  getWwwLocation() {
    const appEnv = process.env.NEXT_PUBLIC_NODE_ENV;
    let baseLocation;
    if (appEnv === 'staging') {
      baseLocation = 'https://www.lingualbox.jp';
    } else if (appEnv === 'prod') {
      baseLocation = 'https://www.lingualbox.com';
    } else {
      baseLocation = 'http://www.lingualbox.loc:' + window.location.port;
    }
    return baseLocation;
  },

  redirectToWww(locale = null, path = null) {
    const baseLocation = getWwwLocation();
    const subdomain = window.location.host.split('.')[0];
    let localeParam = locale;
    if (!locale) {
      switch (subdomain) {
        case 'ja':
          localeParam = 'ja';
          break;
        case 'es':
          localeParam = 'es';
          break;
        case 'pt':
          localeParam = 'pt';
          break;
        case 'ru':
          localeParam = 'ru';
          break;
        case 'tw':
          localeParam = 'tw';
          break;
        default:
          localeParam = 'en';
          break;
      }
    }
    if (path) {
      window.location = baseLocation + path + '?locale=' + localeParam;
    } else {
      window.location =
        baseLocation + window.location.pathname + '?locale=' + localeParam;
    }
  },

  getCanonical(language, path) {
    switch (language) {
      case 'ja':
        return `https://ja.lingualbox.com/${path}`;
      case 'es':
        return `https://es.lingualbox.com/${path}`;
      case 'pt':
        return `https://pt.lingualbox.com/${path}`;
      case 'ru':
        return `https://ru.lingualbox.com/${path}`;
      case 'tw':
        return `https://tw.lingualbox.com/${path}`;
      default:
        return `https://www.lingualbox.com/${path}`;
    }
  },

  getAlternates(path, subdomain) {
    const alternates = [
      {
        hreflang: 'en',
        subdomain: 'www',
        href: `https://www.lingualbox.com${path}`,
      },
      {
        hreflang: 'ja',
        subdomain: 'ja',
        href: `https://ja.lingualbox.com${path}`,
      },
      {
        hreflang: 'ru',
        subdomain: 'ru',
        href: `https://ru.lingualbox.com${path}`,
      },
      {
        hreflang: 'pt',
        subdomain: 'pt',
        href: `https://pt.lingualbox.com${path}`,
      },
      {
        hreflang: 'es',
        subdomain: 'es',
        href: `https://es.lingualbox.com${path}`,
      },
      {
        hreflang: 'tw',
        subdomain: 'tw',
        href: `https://tw.lingualbox.com${path}`,
      },
    ];
    _.remove(alternates, (link) => link.subdomain === subdomain);
    return alternates;
  },

  getLocaleFromLang(lang) {
    switch (lang) {
      case 'ja':
        return 'ja';
      case 'es':
        return 'es';
      case 'pt':
        return 'pt';
      case 'ru':
        return 'ru';
      case 'tw':
        return 'tw';
      default:
        return 'en';
    }
  },

  getLangFromLocale(locale) {
    switch (locale) {
      case 'ja':
        return 'ja';
      case 'es':
        return 'es';
      case 'pt':
        return 'pt';
      case 'ru':
        return 'ru';
      case 'tw':
        return 'tw';
      default:
        return 'en';
    }
  },

  getI18nFormFromLocale(locale) {
    switch (locale) {
      case 'ja':
        return 'ja-JP';
      case 'es':
        return 'es-ES';
      case 'pt':
        return 'pt-BR';
      case 'ru':
        return 'ru-RU';
      case 'tw':
        return 'zh-TW';
      default:
        return 'en-US';
    }
  },

  getLocaleFromI18n(i18nForm) {
    switch (i18nForm) {
      case 'ja-JP':
        return 'ja';
      case 'es-ES':
        return 'es';
      case 'pt-BR':
        return 'pt-BR';
      case 'ru-RU':
        return 'ru';
      case 'zh-TW':
        return 'tw';
      default:
        return 'en';
    }
  },

  getLangFromSubdomain(subdomain) {
    switch (subdomain) {
      case 'www':
        return 'en';
      case 'es':
      case 'ja':
      case 'ru':
      case 'tw':
      case 'pt':
        return subdomain;
      default:
        return 'en';
    }
  },

  getHtmlLangFromSubdomain(subdomain) {
    switch (subdomain) {
      case 'ja':
      case 'es':
      case 'pt':
      case 'ru':
      case 'www':
        return subdomain;
      case 'tw':
        return 'zh-Hant';
      default:
        return 'en';
    }
  },

  getSiteUrl(language) {
    switch (language) {
      case 'en':
        return 'https://www.lingualbox.com';
      case 'ja':
        return 'https://ja.lingualbox.com';
      case 'es':
        return 'https://es.lingualbox.com';
      case 'pt':
        return 'https://pt.lingualbox.com';
      case 'tw':
        return 'https://tw.lingualbox.com';
      case 'ru':
        return 'https://ru.lingualbox.com';
      default:
        return 'https://www.lingualbox.com';
    }
  },
};

export const isMobile = () => {
  if (typeof window === 'undefined') return false;
  if (window.innerWidth <= 768) {
    return true;
  } else {
    return false;
  }
};

export default appUtils;
